var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pure-g",attrs:{"id":"main-wrap"}},[_c('div',{staticClass:"pure-u-3-5",attrs:{"id":"main-col"}},[_c('button',{staticClass:"pure-button",attrs:{"id":"add-grape-button"}},[_vm._v("Add a Grape")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3a5e162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminUpdateData.vue
// module id = null
// module chunks = 